import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  /**
    * @author Ministerio de cultura
    * @createdate 2024-12-20
    * Metodo que me permite truncar un texto mediante el limite pasado por parametro. 
    * @param value Cadena de texto.
    * @param limit Limite por el cual se va a truncar.
  */
  transform(value: string, limit: number = 20): string {
    if (!value) return value;
    return value.length > limit ? `${value.substring(0, limit)}...` : value;
  }
}